"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StickyBanner = _interopRequireDefault(require("../../StickyBanner/StickyBanner"));
var FlexStickyBanner = function FlexStickyBanner(_ref) {
  var text = _ref.text,
    link = _ref.link,
    noMarginTop = _ref.noMarginTop,
    noMarginBottom = _ref.noMarginBottom;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: noMarginTop && 'calc(-1 * var(--space-xxl))',
      marginBottom: noMarginBottom && 'calc(-1 * var(--space-xxl))'
    }
  }, /*#__PURE__*/_react["default"].createElement(_StickyBanner["default"], {
    text: text,
    link: link
  }));
};
FlexStickyBanner.propTypes = {
  text: _propTypes["default"].string,
  link: _propTypes["default"].string,
  noMarginTop: _propTypes["default"].bool,
  noMarginBottom: _propTypes["default"].bool
};
var _default = exports["default"] = FlexStickyBanner;